//#region src/core/ui/playback-rate-radio-group/data.ts
const PlaybackRateRadioGroupDataAttrs = {
	/** Current playback rate. */
	rate: "data-rate",
	/** Present when playback rate selection is disabled. */
	disabled: "data-disabled",
	/** Present when playback rate selection is unavailable. */
	hidden: "data-hidden",
	/** Indicates playback rate availability (`available` or `unavailable`). */
	availability: "data-availability"
};
//#endregion
export { PlaybackRateRadioGroupDataAttrs };

//# sourceMappingURL=data.js.map